<template>
  <ResourceForm
    type="employee"
    @close="$emit('close')"
    @created="$emit('created', $event)"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ResourceForm from './resource-form/index.vue';

export default defineComponent({
  components: {
    ResourceForm,
  },
  emits: ['close', 'created'],
});
</script>
